import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../api/axios';

function Quote() {
    const [quotes, setQuotes] = useState([ ]);

    const getQuotes = async () => {    
        const sessionId = localStorage.getItem('sessionId');    
        try {
          // Replace with your Dialogflow API endpoint
          const response = await axiosInstance.get('/quotes', {
            session_id: sessionId
          });
    
          const quotes = response.data.quotes;
          if (quotes) {
            setQuotes(quotes);
          }
        } catch (error) {
          console.error('Error sending message:', error);
        }
      };

    useEffect(() => {
        getQuotes();
      }, []);

      return (
        <div className="w-full max-w-4xl mx-auto bg-white rounded-lg shadow-lg border border-gray-200">
          <div className="h-[500px] overflow-y-auto p-4">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50 sticky top-0">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Venue</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Address</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Session ID</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Requested</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Received</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Content</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {quotes.map((quote, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{quote.id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{quote.venue.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{quote.venue.address}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{quote.chat_session_id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{quote.quote_requested}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{quote.quote_received}</td>
                    <td className="px-6 py-4 text-sm text-gray-900">
                      <div className="max-w-xs break-words">{quote.content}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );



      
}
export default Quote;